import React from "react";
import PropTypes from 'prop-types';

const Winner = ({ equipe }) => {
    if (!equipe) return null;

    return (
        <div className="w-full mb-8">
            <div className="bg-gradient-to-r from-yellow-500 via-yellow-600 to-yellow-700 rounded-lg overflow-hidden shadow-2xl border-2 border-yellow-400">
                <div className="bg-black bg-opacity-40 p-8">
                    <div className="text-center space-y-4">
                        <div className="text-yellow-300 text-2xl font-bold tracking-widest uppercase">
                            Champion du first stand
                        </div>
                        
                        <img 
                            src={`${process.env.PUBLIC_URL}/images/equipes/${equipe.logo}`} 
                            alt={equipe.name}
                            className="w-32 h-32 mx-auto rounded-lg object-contain drop-shadow-lg"
                            onError={(e) => e.target.style.display = 'none'}
                        />
                        
                        <div className="space-y-2">
                            <h2 className="text-4xl font-bold text-white font-poppins drop-shadow-lg">
                                {equipe.name}
                            </h2>
                            <p className="text-xl text-yellow-100 font-semibold">
                                {equipe.teamtag}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Winner.propTypes = {
    equipe: PropTypes.object.isRequired,
};

export default Winner;
